import { DestroyRef, Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class BackUrlTrackingService {
  private readonly router = inject(Router);
  private readonly environmentService = inject(EnvironmentService);
  private readonly destroyRef = inject(DestroyRef);
  private started = false;

  start(): void {
    if (this.started) return;
    this.started = true;

    // The router may not have completed its initial navigation yet. Use the
    // browser URL so a directly opened route keeps its query string.
    this.environmentService.rememberNavigatedUrl(globalThis.location.href);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        this.environmentService.rememberNavigatedUrl(globalThis.location.href);
      });
  }
}
